import EventEmitter from 'events';
import AppControlService from '@/soprasolar-project/services/AppControl';
import axios from 'axios';
import Symbol from 'es6-symbol/polyfill';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class FileService extends EventEmitter {
  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._isUploading = true;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new FileService(singletonEnforcer);
    }
    return this[singleton];
  }

  send(document) {
    return new Promise( (resolve, reject) => {
      const token = AppControlService.token;
      if (!token) {
        reject('token is empty');
        return;
      }
      this._isUploading = true;
      const formData = new FormData();
      formData.append('file', document);
      axios.post(`/api/project-applications/${token}/upload`, formData, {
        onUploadProgress: (progressEvent) => {
          document.progress = progressEvent.progress ? Math.round(100 * progressEvent.progress) : 0;
        }
      }).then((res) => {
        document.progress = 100;
        setTimeout(() => {
          document.progress = null;
        }, 400);
        this._isUploading = false;
        resolve(res.data);
      }).catch((err) => {
        console.error(err);
        document.hasError = true;
        document.progress = null;
        this._isUploading = false;
        reject(err);
      })
    });
  }
}
export default FileService.getInstance();
